module.exports = __webpack_public_path__ + "static/img/companyProducts3.9e110318.png";